import { React, useState, useEffect } from 'react';
import checkmark from '../images/checkmark.png';
import xmark from '../images/x.jpg';
import { ENDPOINT_PATH } from '../config';
import ReviewingImages from '../components/reviewingImages';

import { authFetch } from '../utils/authFetch';
/* This version is currently only styled on desktop versions */

const CheckoutSuccess = (props) => {

    const [loading, setLoading] = useState(true);
    const [nsfw, setNSFW] = useState(false);
    const [error, setError] = useState(null);
    // Note: loading and error states are set but not displayed in UI currently

    useEffect(() => {
        const verifyPayment = async () => {
            const urlParameters = new URLSearchParams(window.location.search);
            const sessionID = urlParameters.get('sessionID');

            if (!sessionID) {
                setError('No session ID found.');
                setLoading(false);
                return;
            }

            try {
                const response = await authFetch(ENDPOINT_PATH + `/api/check-session?sessionID=${sessionID}`);
                const session = await response.json();

                console.log("Payment Status: " + session.paymentStatus)
                console.log("Payment Intent:", session.payment_intent);
                console.log("Payment Intent Status:", session.payment_intent?.status);

                console.log(localStorage.getItem('metricAdded_' + sessionID));
                if (localStorage.getItem('metricAdded_' + sessionID) === 'true') {
                    console.log('Metric has already been added for this session');
                    return;
                }

                // Get the shopping cart data of current user
                const userData = localStorage.getItem('user');
                console.log("userData: " + userData);
                let userID;
                let userEmail;
                if (userData) {
                    const userObj = JSON.parse(userData);
                    userID = userObj.uid;
                    userEmail = userObj.email;
                }

                // Get the current user's shopping cart
                const cart = await authFetch(ENDPOINT_PATH + `/api/shopping-cart?userID=${userID}`);
                const cartData = await cart.json();

                // Create a map containing the purchased frames
                const finalProductsPromise = cartData.finalProducts.map(async (finalProduct) => {
                    const finalProductID = finalProduct.finalProduct._path.segments[1];

                    const response = await authFetch(ENDPOINT_PATH + `/api/final-product?finalProductID=${finalProductID}`);
                    const finalProductData = await response.json();

                    return {
                        finalProductID,
                        finalProductDoc: finalProductData,
                        quantity: parseInt(finalProduct.quantity, 10)
                    }
                });

                const userHistoryFinalProductsPromise = cartData.finalProducts.map(async (finalProduct) => {
                    const finalProductID = finalProduct.finalProduct._path.segments[1];

                    return {
                        finalProductID,
                        quantity: parseInt(finalProduct.quantity, 10)
                    }
                });

                const finalProducts = await Promise.all(finalProductsPromise);
                const userHistoryFinalProducts = await Promise.all(userHistoryFinalProductsPromise);
                
                let OrderHasNSFW = false;

                for (const product of finalProducts) {
                    console.log("isFromGallery: " + product.finalProductDoc.isFromGallery)
                    console.log("product: ", product)
                    if (product.finalProductDoc.isFromGallery === true) {
                        continue
                    }
                    let imageLink = product.finalProductDoc.uploadedImage;
                    //send imageLink for processing by backend API
                    const checkresults = await authFetch(ENDPOINT_PATH + `/api/check-for-nsfw`, {
                        method: "POST",
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            imageUrl: imageLink
                        })
                    })
                    const body = await checkresults.json()
                    if (checkresults.ok) {
                        console.log("Check Results:", body);
                    }
                    //now check categories for any NSFW
                    for (const category of body.categoriesAnalysis) {
                        console.log(category)
                        if (category.severity >= 4) {
                            OrderHasNSFW = true;
                            setNSFW(true)
                        }
                    }
                }
                
                console.log("Has NSFW: " + OrderHasNSFW);   

                if (OrderHasNSFW !== true) {
                    // API to put the final product in a orders page for Admin
                    authFetch(ENDPOINT_PATH + `/api/add-admin-order`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            userID: userID,
                            finalProducts: finalProducts,
                            address1: localStorage.getItem('ADDRESS_LINE_1'),
                            city: localStorage.getItem('CITY'),
                            postalCode: localStorage.getItem('POSTAL_CODE'),
                            state: localStorage.getItem('STATE'),
                            firstName: localStorage.getItem('FIRST_NAME'),
                            lastName: localStorage.getItem('LAST_NAME'),
                        })
                    }).catch(error => console.error("Error adding to admin order history in checkout: ", error));


                    // API to put the final product in the users order history
                    authFetch(ENDPOINT_PATH + `/api/add-user-order-history`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            userID: userID,
                            finalProducts: userHistoryFinalProducts,
                            totalPayment: session.totalPayment,
                        })
                    }).catch(error => console.error("Error adding to user order history in checkout: ", error));
                    //EXECUTE STRIPE PAYMENT HOLD

                    authFetch(ENDPOINT_PATH + `/api/send-confirmation-email`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            finalProducts: finalProducts,
                            email: userEmail
                        })
                    })

                    authFetch(ENDPOINT_PATH + `/api/clear-shopping-cart`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            userID: userID
                        })
                    })
                }


                
                console.log("Session Intent ID:");
                console.log(session.payment_intent)

                authFetch(ENDPOINT_PATH + '/api/handle-payment-intent-capture', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        cancel: OrderHasNSFW,
                        paymentIntentId: session.payment_intent.id
                    })
                });


                // payment status should be checked after the payment is captured or denied
                // Use payment_intent.status instead of paymentStatus to avoid timing issues 
                // Payment intent status updates immediately, while checkout session payment_status has a delay
                // Check for both 'succeeded' and 'requires_capture' since manual capture payments show 'requires_capture' until captured

                if (session.payment_intent && (session.payment_intent.status === 'succeeded' || session.payment_intent.status === 'requires_capture')) {
                    // Run through each final product in the user's cart and add purchase metrics.
                    let metricsSuccess = true;
                    let metricsErrors = [];
                    
                    for (const finalProducts of cartData.finalProducts) {
                        const finalProductID = finalProducts.finalProduct._path.segments[1];
                        const finalProduct = await authFetch(ENDPOINT_PATH + `/api/final-product?finalProductID=${finalProductID}`);
                        const finalProductData = await finalProduct.json();

                        try {
                            const metricResponse = await authFetch(ENDPOINT_PATH + `/api/add-purchase-metric`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    finalProductDoc: finalProductData,
                                    quantity: parseInt(finalProducts.quantity, 10)
                                })
                            });

                            if (!metricResponse.ok) {
                                const errorText = await metricResponse.text();
                                console.error(`Error adding purchase metric for product ${finalProductID}:`, errorText);
                                metricsSuccess = false;
                                metricsErrors.push(`Product ${finalProductID}: ${errorText}`);
                            } else {
                                console.log(`Metrics added successfully for product ${finalProductID}`);
                            }
                        } catch (error) {
                            console.error(`Error adding purchase metric for product ${finalProductID}:`, error);
                            metricsSuccess = false;
                            metricsErrors.push(`Product ${finalProductID}: ${error.message}`);
                        }
                    }

                    // Only set flag if all metrics were added successfully
                    if (metricsSuccess) {
                        localStorage.setItem('metricAdded_' + sessionID, 'true');
                        console.log('All purchase metrics added successfully');
                    } else {
                        console.error('Some metrics failed to add:', metricsErrors);
                        // Don't set flag so it can retry on page refresh
                    }
                } else {
                    setError('Payment not successful.');
                }
            } catch (error) {
                console.error('Error verifying payment. ', error);
                setError('Error verifying payment');
            } finally {
                setLoading(false);
            }
        };


        verifyPayment(); // Call the function once after the component is mounted
    }, []); // Empty dependency array ensures this runs only once

    return (
        <div className="popup">
            <div className="checkout-popup-inner row">
                {loading &&
                    <ReviewingImages/>
                }
                {!loading &&
                    <div className="col pb-5">
                        <div className="checkout-successFail-wrapper">
                            
                            {!nsfw &&
                                <div>
                                    <div className="checkout-successFail-icon">
                                        <img src={checkmark} height="60" width="60" alt="checkmark icon" />
                                    </div>
                                    <div className="checkout-successFail-text">
                                    <h2>
                                        Thank you for your order!
                                    </h2>
                                    <h6>
                                        Your order has been successfully completed. The MyCustomFrame team will
                                        reach out to you shortly regarding your order.
                                    </h6>
                                    </div>
                                    <div className="text-center pt-2">
                                        <a href="/">
                                            <button className="btn button-dark">Back to MyCustomFrame</button>
                                        </a>
                                    </div>
                                </div>
                            }
                            {nsfw &&
                                <div>
                                    <div className="checkout-successFail-icon">
                                        <img src={xmark} height="100" width="100" alt="x icon"/>
                                    </div>
                                    <div className="checkout-successFail-text">
                                    <h2>
                                        Order unsuccessful
                                    </h2>
                                    <h6>
                                        Your order was flagged for inappropriate content. Please review the items in your order and try again.
                                    </h6>
                                    </div>
                                    <div className="text-center pt-2">
                                        <a href="/">
                                            <button className="btn button-dark">Back to MyCustomFrame</button>
                                        </a>
                                    </div>
                                </div>
                            }
                            
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default CheckoutSuccess;
